import { createSelector } from "reselect";

export const getLocale = state => state.app.locale;